import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { intervento } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { StatoFatturazioneIntervento } from '@/routes/interventions/InterventionEditor.enums'
import { confirm } from 'devextreme/ui/dialog'
import notify from 'devextreme/ui/notify'
import { useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export const createDuplicateIntervention = async (interventionId: number) => {
  const { service, client } = useQsAdminApiManager.getState()
  // Read the saved intervention, including relationships that the grid may not have loaded.
  const { data: source } = await service.intervento(interventionId).query((builder) => {
    builder.expanding('sede', (site) => site.select('id'))
    builder.expanding('task', (task) => task.select('id'))
    builder.expanding('impiegati', (technicians) => technicians.select('id'))
    builder.expanding('riferimenti_cliente', (references) => references.select('id'))
  })
  const today = new Date()
  const intervention = {
    id: 0,
    data: today.toISOString(),
    anno_rif: today.getFullYear(),
    sede: source.sede ? { id: source.sede.id } : null,
    task: source.task ? { id: source.task.id } : null,
    impiegati: source.impiegati?.map(({ id }) => ({ id })) ?? [],
    riferimenti_cliente: source.riferimenti_cliente?.map(({ id }) => ({ id })) ?? [],
    mattina_inizio: source.mattina_inizio,
    mattina_fine: source.mattina_fine,
    pomeriggio_inizio: source.pomeriggio_inizio,
    pomeriggio_fine: source.pomeriggio_fine,
    durata_viaggio: source.durata_viaggio,
    note: source.note,
    locale: source.locale,
    remote: source.remote,
    compensativo: source.compensativo,
    ignorePackages: source.ignorePackages,
    inviato: false,
    stato_fatturazione: { id: StatoFatturazioneIntervento['DA FATTURARE'] },
  }
  // Use normal creation so hours and package usage are generated by the API.
  const response = await client.post<intervento>('api/intervento/intervention', { intervention })
  return response.data
}

export const useDuplicateIntervention = () => {
  const navigate = useNavigate()
  const { clientId } = useParams()
  const inProgress = useRef(false)
  const [isDuplicating, setIsDuplicating] = useState(false)

  const duplicateIntervention = async (interventionId: number) => {
    if (inProgress.current) return
    inProgress.current = true
    setIsDuplicating(true)
    try {
      const confirmed = await confirm('Sei sicuro di voler duplicare questo intervento?', 'Duplicazione intervento')
      if (!confirmed) return

      const copy = await createDuplicateIntervention(interventionId)
      const basePath = clientId ? `/clients/${clientId}/interventions` : '/interventions'
      navigate(`${basePath}/${copy.id}`)
    } catch (error) {
      notify(`Errore duplicazione intervento. Dettagli: ${error}`, 'error', 5000)
    } finally {
      inProgress.current = false
      setIsDuplicating(false)
    }
  }

  return { duplicateIntervention, isDuplicating }
}
